@if (appointmentListType !== appointmentType.PatientSearch) {
  <div
    class="mb-2 flex flex-wrap items-center justify-between gap-3"
    >
    <div class="flex flex-col gap-0">
      <p class="text-xl">{{title}}</p>
      @if (appointmentListType === appointmentType.PastAppointments) {
        <span class="text-sm">Results displayed are limited to the past 6 months. For older records, please contact our office.</span>
      }
    </div>
    <button
      mat-stroked-button
      type="button"
      [matMenuTriggerFor]="exportMenu"
      [disabled]="fullDataSource.isLoading() || detailListResource.isLoading() || !fullDataSource.value()?.count || isExporting()">
      {{ isExporting() ? 'Exporting...' : 'Export' }}
    </button>
  </div>
} @else {
  <div class="mb-2">
    <p class="text-xl">{{title}}</p>
  </div>
}
<mat-menu #exportMenu="matMenu">
  <button mat-menu-item type="button" (click)="exportAppointments('csv')">CSV</button>
  <button mat-menu-item type="button" (click)="exportAppointments('xlsx')">Excel (.xlsx)</button>
</mat-menu>
<hr class="bg-green" style="width: 100%; min-width: 500px; height: 3px; border: none;">
<div class="flex w-full min-w-0 max-w-full max-h-[calc(60dvh-1.25rem)] flex-col">
  <div class="min-h-0 flex-1 overflow-x-auto overflow-y-auto touch-auto">
  <table
    mat-table
    [dataSource]="tableDataSource",
    matSort
    matSortActive="date"
    [matSortDirection]="defaultSortDirection"
    (matSortChange)="onSortChange($event)"
    matSortDisableClear>
    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> APPT DATE & TIME </th>
      <td mat-cell *matCellDef="let appointment"> {{ appointment.date }} {{ appointment.time }} </td>
    </ng-container>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> PATIENT NAME </th>
      <td mat-cell *matCellDef="let appointment" > {{ appointment.patient?.firstName  || '' }} {{appointment.patient?.lastName  || '' }} </td>
    </ng-container>
    <ng-container matColumnDef="dob">
      <th mat-header-cell *matHeaderCellDef> DOB </th>
      <td mat-cell *matCellDef="let appointment"> {{ appointment.patient?.dateOfBirth || ''}} </td>
    </ng-container>
    <ng-container matColumnDef="iowaOrthoProvider">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> IOWA ORTHO PROVIDER </th>
      <td mat-cell *matCellDef="let appointment"> {{ appointment.iowaOrthoProvider?.firstName || '' }} {{ appointment.iowaOrthoProvider?.lastName || '' }} </td>
    </ng-container>
    <ng-container matColumnDef="location">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> APPT LOCATION </th>
      <td mat-cell *matCellDef="let appointment"> {{ appointment.location }} </td>
    </ng-container>
    @if (showReferringProvider) {
      <ng-container matColumnDef="referringProvider">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> REFERRING PROVIDER </th>
        <td mat-cell *matCellDef="let appointment"> {{ appointment.referringProvider?.firstName || '' }} {{ appointment.referringProvider?.lastName || '' }} </td>
      </ng-container>
    }
    <ng-container matColumnDef="visit">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> VISIT </th>
      <td mat-cell *matCellDef="let appointment"> {{ appointment.type }} </td>
    </ng-container>
    @if (showStatus) {
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef> STATUS </th>
        <td mat-cell *matCellDef="let appointment"> {{ appointment.status }} </td>
      </ng-container>
    }

    <tr class="sticky top-0 z-10 bg-white" mat-header-row *matHeaderRowDef="getDisplayedColumns()"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onRowClicked(row)"></tr>
  </table>
  </div>
  @if (totalPages !== 0) {
    <div class="flex w-full shrink-0 justify-end bg-white table-pagination">
      <app-pagination
        [currentPage]="resourceSortOptions().pageNumber"
        [totalPages]="totalPages"
        (pageChange)="onPageChange($event)"
      />
    </div>
  }
</div>
@if (detailListResource.isLoading() || fullDataSource.isLoading()) {
  <div
    class="w-full flex justify-center my-10"
    >
    <mat-spinner></mat-spinner>
  </div>
}

@if (tableDataSource.data.length === 0 && !detailListResource.isLoading() &&  !fullDataSource.isLoading()) {
  <div
    class="w-full text-center my-10"
    >
    <p class="text-sm">{{emptyTableMessage}}</p>
  </div>
}
